// ProjectActivityCard — the Overview tab's Activity feed card: the newest
// activity-log events scoped to this project via the confirmed `projectIds`
// body param on POST activity-logs/list. A short fixed feed (5 rows, no
// pagination and no "view all" — the full load-more feed lives on the Activity
// tab, ProjectActivity). Rows render through the shared ProjectActivityList so
// both surfaces stay identical.

import { useTranslation } from 'react-i18next';
import { Card, Icon } from '@/components/common';
import { useGetActivityLogsQuery } from '@/api/endpoints/activityLogApi';
import ProjectActivityList from './ProjectActivityList';

const FEED_LIMIT = 5;

interface ProjectActivityCardProps {
  projectId: string;
}

const ProjectActivityCard = ({ projectId }: ProjectActivityCardProps) => {
  const { t } = useTranslation();
  const { data, isLoading, isError } = useGetActivityLogsQuery(
    { projectIds: [projectId], page: 1, limit: FEED_LIMIT },
    { refetchOnMountOrArgChange: true },
  );
  const items = data?.items ?? [];

  return (
    <Card
      padded={false}
      head={
        <span className='project-detail__section-title'>
          <Icon name='activity' size={15} />
          {t('projects_detail_activity')}
        </span>
      }
    >
      {isLoading ? (
        <p className='project-detail__empty'>{t('text_loading')}</p>
      ) : isError ? (
        <p className='project-detail__empty'>
          <Icon name='circle-alert' size={26} />
          {t('error_generic')}
        </p>
      ) : items.length === 0 ? (
        <p className='project-detail__empty'>{t('projects_detail_no_activity')}</p>
      ) : (
        <ProjectActivityList items={items} />
      )}
    </Card>
  );
};

export default ProjectActivityCard;
